import { render } from "./_workspaceId.vue?vue&type=template&id=4086bbaf&scoped=true"
import script from "./_workspaceId.vue?vue&type=script&lang=js"
export * from "./_workspaceId.vue?vue&type=script&lang=js"

import "./_workspaceId.vue?vue&type=style&index=0&id=4086bbaf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4086bbaf"]])

export default __exports__